import { clearAllBodyScrollLocks } from 'body-scroll-lock';

export default function () {
  document.dispatchEvent(new CustomEvent('menusWillClose'));

  const state = document.querySelector('[data-state]');

  if (state && (state.classList.contains('State--cart-open') || state.classList.contains('State--modal-open'))) {
    const preHeader = document.querySelector('[data-pre-header]');
    const header = document.querySelector('[data-header]');
    if (preHeader) preHeader.style.right = '0';
    if (header) header.style.right = '0';

    const freeShippingBar = document.querySelector('.FreeShippingBar');
    if (freeShippingBar && freeShippingBar.classList.contains('sticky')) {
      freeShippingBar.classList.remove('sticky');
    }

    if (state.classList.contains('State--modal-open')) {
      const main = document.querySelector('main');
      const footer = document.querySelector('[data-footer]');

      // The <main> element is employed in each page. However, it cannot be touched on the cart page,
      // it has a specific class in the cart page and modify the padding due to open a modal there would break the UI.
      // Therefore, it will modify the padding on pages where <main> element has no classes only.
      if (main && !main.classList.length) main.style.paddingRight = '0';
      if (footer) footer.style.paddingRight = '0';

      const modal = document.querySelector('[data-modal].Modal--open');
      const modalId = modal ? modal.id : '';
      if (window.location.hash === `#${modalId}`) {
        window.history.pushState('', document.title, window.location.pathname + window.location.search);
        window.dispatchEvent(new Event('hashchange'));
      }
    }
  } else {
    const sliderCart = document.querySelector('.SliderCart');
    if (sliderCart && sliderCart.classList.contains('has_out_of_stock')) {
      localStorage.removeItem('out_of_stock');
    }
  }

  document.querySelectorAll('[data-site-overlay]').forEach((el) => el.classList.remove('SiteOverlay--active'));
  document.querySelectorAll('[data-search-drawer]').forEach((el) => el.classList.remove('SearchDrawer--open'));
  document.querySelectorAll('[data-cart-toggle]').forEach((el) => el.classList.remove('IconToggle--open'));
  document.querySelectorAll('[data-search-toggle]').forEach((el) => el.classList.remove('IconToggle--open'));
  document.querySelectorAll('[data-modal]').forEach((el) => el.classList.remove('Modal--open'));

  if (state) {
    state.classList.remove('State--mobile-menu-open');
    state.classList.remove('State--cart-open');
    state.classList.remove('State--modal-open');
  }

  const inputs = document.querySelectorAll('[data-search-drawer] form input');
  inputs.forEach((input) => input.blur());

  clearAllBodyScrollLocks();

  document.dispatchEvent(new CustomEvent('menusDidClose'));
}
